import cx from "classnames";
import { LocationDescriptor as To } from "history";
import React from "react";

import { CategoryKey } from "@/mk2/apps/bazaar/components/CategoryFacetOption";
import CategoryFacetOptionsSection from "@/mk2/apps/bazaar/components/CategoryFacetOptionsSection";
import { SubcategoryOption } from "@/mk2/apps/bazaar/components/CategoryFacetSubOptions";
import { HistoryLocationState } from "@/mk2/services/browserHistory";
import {
    BZ2_FILTER_MODAL_CLOSE,
    BZ_CATEGORY_TYPE_LABEL_FOR_CHILDREN,
} from "@/mk/autogenerated/translation";

import styles from "./CategoryFacetOptions.mscss";

export interface CategoryOption {
    key: CategoryKey;
    count?: number;
    to?: [To, Partial<HistoryLocationState>];
    children?: SubcategoryOption[];
}

export interface OwnProps {
    className?: string;
    options?: CategoryOption[];
    selected?: CategoryKey;
    opened?: CategoryKey;

    onSelect(category: CategoryKey);
    onToggle(category: CategoryKey);
    onClose(event: React.MouseEvent<HTMLButtonElement>);
}

type Props = OwnProps;

const CategoryFacetOptions: React.FunctionComponent<Props> = ({
    className,
    options,
    selected = null,
    opened,
    onSelect,
    onToggle,
    onClose,
}) => {
    return (
        <div className={cx(styles.CategoryFacetOptions, className)}>
            <div className={styles.CategoryFacetOptions__content}>
                <div className={styles.CategoryFacetOptions__header}>
                    <div className={styles.CategoryFacetOptions__header__dismiss}>
                        <button
                            className={styles.CategoryFacetOptions__header__dismiss__button}
                            type="button"
                            onClick={onClose}
                        >
                            {BZ2_FILTER_MODAL_CLOSE}
                        </button>
                    </div>
                </div>

                <div className={styles.CategoryFacetOptions__container}>
                    <CategoryFacetOptionsSection
                        options={options}
                        selected={selected}
                        opened={opened}
                        onSelect={onSelect}
                        onToggle={onToggle}
                        label={BZ_CATEGORY_TYPE_LABEL_FOR_CHILDREN}
                    />
                </div>
            </div>
        </div>
    );
};

CategoryFacetOptions.displayName = "CategoryFacetOptions";

export default React.memo<Props>(CategoryFacetOptions);
